
    import './styles.scoped.css';
    export default {
  "header-cell": "awsui_header-cell_1spae_1p6if_93",
  "header-cell-sticky": "awsui_header-cell-sticky_1spae_1p6if_103",
  "header-cell-stuck": "awsui_header-cell-stuck_1spae_1p6if_106",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_1p6if_109",
  "header-cell-sortable": "awsui_header-cell-sortable_1spae_1p6if_115",
  "sorting-icon": "awsui_sorting-icon_1spae_1p6if_128",
  "header-cell-disabled": "awsui_header-cell-disabled_1spae_1p6if_135",
  "header-cell-sorted": "awsui_header-cell-sorted_1spae_1p6if_135",
  "header-cell-content": "awsui_header-cell-content_1spae_1p6if_135",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_1p6if_168",
  "header-cell-text": "awsui_header-cell-text_1spae_1p6if_197",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_1p6if_197",
  "header-cell-ascending": "awsui_header-cell-ascending_1spae_1p6if_203",
  "header-cell-descending": "awsui_header-cell-descending_1spae_1p6if_204"
};
  